<script lang="ts">
    import { _, locale, locales } from "svelte-i18n";
    import { Alert } from "sveltestrap";
    import { appManager } from "../../AppManager";
    import type { UserData } from "@anyways-open/identity-api-client";
    import { get } from "svelte/store";
    import { onMount } from "svelte";

    let visible = true;

    appManager.getIsDesktop().subscribe((isDesktop) => {
        visible = !isDesktop;
    });

    let user: UserData;

    const getUser = async () => {
        user = get(await appManager.getCurrentUserStore());
    };

    onMount(() => {
        if (document.body.clientWidth < 576) {
            appManager.getIsDesktop().set(false);
        } else {
            appManager.getIsDesktop().set(true);
        }
    });
</script>

{#await getUser() then}
    {#if user}
        <Alert
            color="warning"
            isOpen={visible}
            class="rounded-0 w-100 mb-0 py-1">
            <div class="container w-100" style="z-index: unset;">
                <div class="row">
                    <div class="col-12 g-0">
                        <div class="text-center text-sm">
                            {$_("alert.notdesktop.message")}
                        </div>
                    </div>
                </div>
            </div>
        </Alert>
    {/if}
{/await}
